module.exports = __webpack_public_path__ + "img/c033d69.png";